var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlcoholFreeTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 105.36,
    cy: 106.3,
    r: 83.92
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.3,192.72a86.42,86.42,0,1,1,86.42-86.42A86.52,86.52,0,0,1,106.3,192.72Zm0-167.84a81.42,81.42,0,1,0,81.42,81.42A81.51,81.51,0,0,0,106.3,24.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.43,52.92a1.26,1.26,0,0,1,1.25-1.26h6.7a1.25,1.25,0,0,1,1.25,1.25l.08,19.66a1.1,1.1,0,0,1-1.1,1.11h-7a1.11,1.11,0,0,1-1.11-1.1ZM66.07,122.43v34.3c0,3,1.42,4.45,4.25,4.45h31.53c2.85,0,4.15-1.33,4.15-3.89V123a53.32,53.32,0,0,0-4.45-21.17c-.73-1.68-.79-1.83-1.13-2.53a54.11,54.11,0,0,1-5.34-23.43v-23a5.71,5.71,0,0,0-5.71-5.7H82.68A5.71,5.71,0,0,0,77,52.92V76.13a53.24,53.24,0,0,1-5.23,23h0c-.43.89.46-1.21-1.21,2.71A55.31,55.31,0,0,0,66.07,122.43Zm14.66-37.5c.32-2,.57-4.46.7-5.8a1.09,1.09,0,0,1,1.1-1h7.13a1.11,1.11,0,0,1,1.11,1c.07,1.35.24,3.77.55,5.75l.87,4.45a57,57,0,0,0,4.06,11.51,54.18,54.18,0,0,1,5.3,23.34v30.49a2,2,0,0,1-2,2H73.63a3.11,3.11,0,0,1-3.11-3.11V124A53.37,53.37,0,0,1,75.75,101h0a57.3,57.3,0,0,0,4.1-11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.86,121.56H78.31A3.33,3.33,0,0,0,75,124.89v20.94a3.33,3.33,0,0,0,3.33,3.33H93.76a3.33,3.33,0,0,0,3.33-3.33V123.78a2.22,2.22,0,0,0-2.23-2.22Zm-3.33,23.15h-11a1.11,1.11,0,0,1-1.11-1.11V127.11a1.11,1.11,0,0,1,1.11-1.1h11a1.11,1.11,0,0,1,1.11,1.1V143.6A1.11,1.11,0,0,1,91.53,144.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151,111.23c0-3.48-1.51-11.6-2.16-15a1.85,1.85,0,0,0-1.81-1.49H116.31a1.85,1.85,0,0,0-1.81,1.49c-.65,3.36-2.15,11.47-2.15,15,0,10.77,7.06,17,15.79,18.91a1.84,1.84,0,0,1,1.43,1.8v23.13a1.85,1.85,0,0,1-1.85,1.85h-6.37a1.85,1.85,0,0,0-1.84,1.84h0a1.85,1.85,0,0,0,1.84,1.85h20.86a1.84,1.84,0,0,0,1.84-1.85h0a1.84,1.84,0,0,0-1.84-1.84h-6.37a1.84,1.84,0,0,1-1.84-1.85V131.9a1.82,1.82,0,0,1,1.4-1.79C144,128.09,151,121.92,151,111.23Zm-35.84,0A66.52,66.52,0,0,1,117,99.64a1.83,1.83,0,0,1,1.79-1.4h25.76a1.85,1.85,0,0,1,1.8,1.45c.6,2.79,1.85,8.88,1.85,11.53,0,10.54-8.62,16-16.51,16S114.74,121.22,115.18,111.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.43,176.15a6,6,0,0,1-4.52-2.05L44.71,45a6,6,0,0,1,9-7.91L166.94,166.19a6,6,0,0,1-4.51,10Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholFreeTag);
export default __webpack_public_path__ + "static/media/AlcoholFreeTag.03a0210f9be4a848abdb33cbbf64ea23.svg";
export { ForwardRef as ReactComponent };